<template>
  <div v-if="item">
    <ValidationObserver v-slot="{ handleSubmit }">
      <div class="p-4">
        <b-row>
          <b-col cols="12">
            <em class="fas fa-file-times text-orange mr-1" />
            <span class="ml-2">Razón de Denegación</span>
          </b-col>
          <b-col class="mt-4 mt-md-2" cols="12" md="4">
            <ValidationProvider
              v-slot="{ errors }"
              :custom-messages="{ required: 'La Razón es requerida.' }"
              :rules="{ required: true }"
            >
              <CustomDropDown
                v-model="model.reason"
                :custom-error-msg="errors[0]"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Razón:"
                :options="viewmodel.reasons"
              />
            </ValidationProvider>
          </b-col>
          <b-col class="mt-4 mt-md-2" cols="12" md="8">
            <ValidationProvider
              v-slot="{ errors }"
              :custom-messages="{
                required: 'Favor de documentar el comentario.',
              }"
              :rules="{ required: true }"
            >
              <CustomInput
                v-model="model.comment"
                :error="errors[0]"
                label="Comentario:"
              />
            </ValidationProvider>
          </b-col>
          <b-col class="mt-4 text-md-right" cols="12">
            <ActionButton
              class="mr-2"
              i="fas fa-times-circle"
              text="Cancelar"
              variant="danger"
              @click="cancel"
            />
            <ActionButton
              i="fas fa-save"
              text="Guardar"
              variant="success"
              @click="handleSubmit(submit)"
            />
          </b-col>
        </b-row>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import { api } from '@/core/api';
import AdmissionStatus from '@/utils/shared/constants/admissionStatus';

const DENIAL_REASONS_BY_STATUS_API_ENDPOINT =
  'api/compensatoryreferral/referralAdmissionReasonsByStatusId';
const DENY_BY_PROVIDER_API_ENDPOINT =
  'api/compensatoryreferral/saveReferralAdmissionStatusReason';

const ADMISSION_STATUS_CHANGE = {
  [AdmissionStatus.Vinculado]: AdmissionStatus.NoVinculado,
  [AdmissionStatus.Asignado]: AdmissionStatus.Vinculado,
};

const initialModel = () => ({
  reason: null,
  comment: null,
});

export default {
  name: 'DenyByProvider',
  components: {
    CustomDropDown,
    CustomInput,
    ActionButton,
  },
  props: { item: { type: Object, default: null, required: true } },
  data: () => ({
    model: initialModel(),
    viewmodel: {
      reasons: [],
    },
  }),
  computed: {
    // JSF: como el id no esta cuando se inicializa el data.model entonces en el computed
    // no detectara los cambios de la propiedad (id), por lo tanto se hizo un computed separado para este id.
    selectedReasonId() {
      return this.model.reason?.id;
    },
    // JSF: como el statusId no esta cuando se inicializa el prop.item entonces en el computed
    // no detectara los cambios de la propiedad (statusId), por lo tanto se hizo un computed separado para este id.
    statusId() {
      return this.item.statusId;
    },
  },
  async created() {
    await this.getDenialReasons();
  },
  methods: {
    cancel() {
      this.model = initialModel();
      this.$emit('finished');
      this.$emit('cancelled');
    },
    async submit() {
      await this.postDenyByProvider();
      this.model = initialModel();
      this.$emit('finished');
      this.$emit('submitted');
    },
    async getDenialReasons() {
      const { data } = await api.get(DENIAL_REASONS_BY_STATUS_API_ENDPOINT, {
        params: { admissionStatusId: this.item.statusId },
      });
      if (data) {
        this.viewmodel.reasons = data;
      }
    },
    async postDenyByProvider() {
      await api.put(DENY_BY_PROVIDER_API_ENDPOINT, {
        admissionStatusId: ADMISSION_STATUS_CHANGE[this.item.statusId],
        comment: this.model.comment,
        admissionStatusReasonId: this.model.reason.id,
        admissionId: this.item.admissionId,
      });
      this.$emit('refresh');
    },
  },
};
</script>
